// src/utils/lang.js
import i18n from '../i18n';

export const applyClientLang = () => {
  const stored = localStorage.getItem('lang');
  if (stored && stored !== i18n.language) i18n.changeLanguage(stored);
};
export const persistClientLang = (lang) => {
  localStorage.setItem('lang', lang);
};
